import { atom } from 'jotai';
import { atomWithLocalStorage } from '@/recoil/jotaiStorage';
import type {
  RelatedApprovalItem,
  RelatedApprovalRelationType,
} from '@/types/approval';

// localStorage key 는 레거시 JS 와 동일 — 이전 선택 언어를 그대로 이어쓰기.
export const translationFromLangAtom = atomWithLocalStorage<string | null>(
  'translation_from_lang',
  null,
);

export const translationToLangAtom = atomWithLocalStorage<string | null>(
  'translation_to_lang',
  null,
);

// documentId: 현재 문서와 불일치 시 stale 로 보고 컨테이너 mount 시 reset.
export type ApprovalTranslationResult = {
  documentId: string;
  targetLanguage: string;
  translatedSubject: string;
  translatedContent: string;
};

// 영속 — 새로고침 후 isTranslated 복원에 필요해 결과 자체를 보관.
export const translationResultAtom =
  atomWithLocalStorage<ApprovalTranslationResult | null>(
    'translation_result',
    null,
  );

// 취소 버튼은 이 atom 만 false 로 → 결과는 캐시된 채 토글 가능.
export const isTranslatedAtom = atomWithLocalStorage<boolean>(
  'translation_is_translated',
  false,
);

// in-flight 플래그(transient). 문서 전환/언마운트 시 index.tsx 가 reset.
export const isTranslatingAtom = atom<boolean>(false);

// ===== 연관품의 편집 모드 (영속 X — 이탈 시 휘발, PHP 동작과 동일) =====

export const relatedEditModeAtom = atom<boolean>(false);

// 검색으로 새로 선택한 항목. 저장 시 docId 만 추려 POST /relations.
export type RelatedSelected = Record<
  RelatedApprovalRelationType,
  RelatedApprovalItem[]
>;

const EMPTY_RELATED_SELECTED: RelatedSelected = {
  parents: [],
  children: [],
  related: [],
};

export const relatedSelectedAtom = atom<RelatedSelected>(
  EMPTY_RELATED_SELECTED,
);

// X 로 삭제한 기존 연결. 저장 시 DELETE /relations.
export type RelatedDeletedItem = {
  relationType: RelatedApprovalRelationType;
  relatedId: string;
};

export const relatedDeletedAtom = atom<RelatedDeletedItem[]>([]);

// 결재 AI 어시스턴트 패널 글자 크기 단계(0 기본 · 1 크게 · 2 아주 크게) — 다음에 열어도 유지 (PORTAL-15728)
export const approvalAiFontLevelAtom = atomWithLocalStorage<number>(
  'approval_ai_font_level',
  0,
);

// AI 어시스턴트 전달 카드에서 이미 전달한 답변(messageId) — 패널을 다시 열어도 「전달했습니다」로 (PORTAL-15736)
export const approvalAiSharedMessagesAtom = atomWithLocalStorage<
  Record<string, number>
>('approval_ai_shared_messages', {});

// AI 패널을 연 채 결재했을 때 — 화면을 새로 띄워 여는 다음 문서에서도 패널을 연다(한 번 쓰고 지움) (PORTAL-15735)
export const approvalAiCarryOverAtom = atomWithLocalStorage<{
  from: string;
} | null>('approval_ai_carry_over', null);
